module.exports = __webpack_public_path__ + "static/media/contact.1e9201ec.png";